import { Entity } from 'src/app/core/utils/entity';

export abstract class ClaimMultiEntity extends Entity {
  constructor(
    // Usuario
    public id: string,
    public userId?: string,
    public rol?: string,

    // Primer step: Datos de reclamante
    public razonSocial?: string,
    public companyCuit?: string,
    public companyEmail?: string,
    public companyPhone?: string,
    public streetCompany?: string,
    public numberCompany?: string,
    public floorApartmentCompany?: string,
    public towerCompany?: string,
    public postalCodeCompany?: string,
    public provinceCompany?: string,
    public cityCompany?: string,
    public claimantTypePerformance?: string,
    public departmentId?: string,

    // Representación de la empresa
    public lastName?: string,
    public name?: string,
    public cuil?: string,
    public claimantPosition?: string,
    public phone?: string,
    public email?: string,
    public birthday?: string,

    // Archivos
    public file?: string[],

    // Segundo step: Datos de reclamado
    public employees: EmployeesDto[] = [],

    // Tercer step: Detalle de reclamo
    public selecterObjectOfClaim?: string[],
    public textClaimDetails?: string,
    public extraDocumentationPdf?: string[],
    public selectedOwnRight?: string,
    public lawyerFullName?: string,
    public lawyerRegistrationNumber?: string,
    public lawyerEmail?: string,
    public consent?: boolean,

    // Datos de la entidad del reclamo
    public confirmInformation?: boolean,
    public claimType?: string,
    public startDate?: Date,
    public numberOfClaim?: number,
    public isBorrador: boolean = false,
    public status?: string,
    public conciliator_full_name?: string,
    public audience_id?: string,
    public date_audience?: string,
    public time_audience?: string,

    //RG
    public type_of_person?: string,
    public representative_last_name?: string,
    public representative_name?: string,
    public representative_cuil?: string,
    public representative_email?: string,
    public representative_phone?: string,
    public representative_street?: string,
    public representative_number?: string,
    public representative_floor_apartment?: string,
    public representative_tower?: string,
    public representative_postal_code?: string,
    public representative_province?: string,
    public representative_city?: string
  ) {
    super();
  }
}

export abstract class EmployeesDto extends Entity {
  constructor(
    public nameClaimed?: string,
    public claimedCuil?: string,
    public claimedEmail?: string,
    public claimedStreet?: string,
    public claimedNumber?: string,
    public claimedFloorApartment?: string,
    public claimedTower?: string,
    public claimedPostalCode?: string,
    public claimedProvince?: string,
    public claimedCity?: string,
    public claimedDni?: string[]
  ) {
    super();
  }
}
